import { Icon } from "@chakra-ui/react";
import React from "react";

export const LogoutIcon = () => (
  <Icon
    size="sm"
    viewBox="0 0 16 16"
    // fill="none"
    xmlns="http://www.w3.org/2000/svg"
    fill="red.300"
  >
    <path
      d="M1.33325 7.99992L4.66659 10.6666V8.66659H10.6666V7.33325H4.66659V5.33325L1.33325 7.99992Z"
      // fill="#FF8787"
    />
    <path
      d="M8.66723 1.99927C7.06389 1.99927 5.55723 2.62393 4.42456 3.75727L5.36723 4.69993C6.24856 3.8186 7.42056 3.3326 8.66723 3.3326C9.91389 3.3326 11.0859 3.8186 11.9672 4.69993C12.8486 5.58127 13.3346 6.75327 13.3346 7.99993C13.3346 9.2466 12.8486 10.4186 11.9672 11.2999C11.0859 12.1813 9.91389 12.6673 8.66723 12.6673C7.42056 12.6673 6.24856 12.1813 5.36723 11.2999L4.42456 12.2426C5.55723 13.3759 7.06389 14.0006 8.66723 14.0006C10.2706 14.0006 11.7772 13.3759 12.9099 12.2426C14.0432 11.1099 14.6679 9.60327 14.6679 7.99993C14.6679 6.3966 14.0432 4.88993 12.9099 3.75727C11.7772 2.62393 10.2706 1.99927 8.66723 1.99927Z"
      // fill="#FF8787"
    />
  </Icon>
);
